import React from "react";
import beneficio1 from '../assets/beneficio11.jpg'; // Adjust the path as necessary
import beneficio2 from '../assets/beneficio21.jpg'; // Adjust the path as necessary
import beneficio3 from '../assets/beneficio31.jpg'; // Adjust the path as necessary
import beneficio4 from '../assets/beneficio41.jpg'; // Adjust the path as necessary
import beneficio5 from '../assets/beneficio51.jpg'; // Adjust the path as necessary
import beneficio6 from '../assets/beneficio61.jpg'; // Adjust the path as necessary
import CallToAction from "./CallToAction";
function Features() {
  return (
    <div className="features">
      <div className="container py-3">
        <h2 className="section-title">¿Por qué usar un avatar interativo?</h2>

        <div className="row text-center">
          <div className="col-md-4 feature-icon">
            <div className="beneficio_img d-flex justify-content-center align-items-center">
              <img src={beneficio1} alt="En que sector usar un asistente virtual con ia-soporte al cliente personalizado" />
            </div>
            <p><b>Soporte al Cliente Personalizado:</b> Brinda asistencia instantánea y responde consultas las <b>24 horas.</b></p>
          </div>
          <div className="col-md-4 feature-icon">
            <div className="beneficio_img d-flex justify-content-center align-items-center">
              <img src={beneficio2} alt="Agente de Ventas Virtua" />
            </div>
            <p><b>Agente de Ventas Virtual:</b> Guía a los clientes potenciales a través de tus <b>ofertas</b> y aumenta las <b>conversiones.</b></p>
          </div>
          <div className="col-md-4 feature-icon">
            <div className="beneficio_img d-flex justify-content-center align-items-center">
              <img src={beneficio3} alt="Storytelling de Marca" />
            </div>
            <p><b>Storytelling de Marca:</b> Permite que tu avatar cuente la historia de tu marca de manera inmersiva.</p>
          </div>
        </div>
        <div className="row text-center">
          <div className="col-md-4 feature-icon">
            <div className="beneficio_img d-flex justify-content-center align-items-center">
              <img src={beneficio4} alt="Capacitación y Onboarding" />
            </div>
            <p><b>Capacitación y Onboarding:</b> Simplifica <b>entrenamientos</b> complejos con presentaciones interactivas y <b>atractivas.</b></p>
          </div>
          <div className="col-md-4 feature-icon">
            <div className="beneficio_img d-flex justify-content-center align-items-center">
              <img src={beneficio5} alt="Demostración de Productos" />
            </div>
            <p><b>Demostración de Productos:</b> Muestra características de manera <b>interactiva</b>, haciendo la <b>experiencia</b> memorable e informativa.</p>
          </div>
          <div className="col-md-4 feature-icon">
            <div className="beneficio_img d-flex justify-content-center align-items-center">
              <img src={beneficio6} alt="Eventos Virtuales" />
            </div>
            <p><b>Eventos Virtuales:</b> Recibe y <b>guía</b> a los <b>asistentes</b> a través de eventos <b>virtuales</b> con un toque <b>humano.</b></p>
          </div>
        </div>
      </div>


    </div>

  );
}

export default Features;
// import React from 'react';
